import type { Ritual, RitualInput, RitualUpdate } from "@akhshy/types";
import { api } from "../lib/api.ts";
import { useResource } from "../lib/useResource.ts";
import { CrudPage } from "../components/organisms/CrudPage.tsx";
import { RitualForm } from "../components/organisms/forms/RitualForm.tsx";
import type { Column } from "../components/organisms/DataTable.tsx";

const columns: Column<Ritual>[] = [
  { header: "Week", render: (i) => <span className="cell-title">#{i.week}</span> },
  { header: "Title", render: (i) => i.title },
  { header: "Date", render: (i) => <span className="marker">{i.displayDate}</span> },
];

export function RitualsPage() {
  const resource = useResource<Ritual, RitualInput, RitualUpdate>(api.rituals);
  return (
    <CrudPage
      intro="Weekly notes on what you're building and learning."
      resource={resource}
      columns={columns}
      emptyText="no ritual entries yet — write week one."
      newLabel="New entry"
      formTitle={(editing) => (editing ? "Edit ritual entry" : "New ritual entry")}
      itemLabel={(i) => i.title}
      renderForm={(p) => <RitualForm {...p} resource={resource} />}
    />
  );
}
